
// import axios from 'axios';
import axios_instance from "../services/axiosClient";

// Define the base URL for the API
const API_BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Fetch product subcategories
 */
export const productSubCategories = async () => {
  try {
    const response = await axios_instance.get(`${API_BASE_URL}/product/subcategories/`);
    console.log("sub categories fetched")
    return response.data;
  } catch (error) {
    console.error('Error fetching product subcategories:', error);
    throw error;
  }
};

/**
 * Fetch cart items
 */
export const getCartItems = async () => {
  try {
    const response = await axios_instance.get(`${API_BASE_URL}/order/carts/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching cart items:', error);
    throw error;
  }
};

/**
 * Additional API calls for products, categories, or other endpoints
 */
export const getAllProduct = async () => {
  try {
    const response = await axios_instance.get(`${API_BASE_URL}/product/products/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching all products:', error);
    throw error;
  }
};
